










































































































































































































































































































































































































































































































































































































import { navigateTo } from '@/common/RouteUtils';
import { Component, Provide, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import {
	ProductsApi,
	Org,
	VatsApi,
	EntityStatus,
	Vat,
	Product,
	Transceiver,
	Audit,
	BillingApi,
	OrgsApi,
	EntityLocation,
	ProductAccessory,
	ProductType,
	SimproJobDetails,
	Entities,
	ProductStatus,
	ProductOrderStatusEnum,
} from '@/api';
import vue2Dropzone from 'vue2-dropzone';
import Notifications from '@/components/tables/notifications.vue';
import VatDisplay from '@/components/vat-display.vue';
import { VirtualTableState } from '@/typings/datatable';
import Toast from '@/components/display/toast.vue';
import { validationMixin } from 'vuelidate';
import TitleMixin from '@/mixins/title-mixin';
import EventSubscriptions from '@/components/tables/event-subscriptions.vue';
import ManageEventSubscriptions from '@/components/manage-event-subscriptions.vue';
import EditChargesModal from '@/pages/account/organisations/billing/EditPlanChargesModal.vue';
import AddNote from '@/components/add business objects/addNote.vue';
import AddUserForm from '@/components/add business objects/add-user/AddUserForm.vue';
import UsersTable from '@/components/tables/users-table.vue';
import ChangeProductOrgModal from '../ChangeProductOrgModal.vue';
import OrgSuggest from '@/components/form pickers/orgSuggest.vue';
import ProductTrialModal from '@/components/ProductTrialModal.vue';
import { required, email, minLength, numeric } from 'vuelidate/lib/validators';
import {
	getProductBillingAttributes,
	OrdwayPlan,
	OrdwaySubscriptionParams,
	ProductOrdwayAttributes,
} from '@/models/ordway';
import { OrdwayService } from '@/services/ordway-service';
import { AxiosError, AxiosResponse } from 'axios';
import SimPro from '@/components/tables/simPro.vue';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';
import ExternalLinkButton from '@/components/elements/buttons/external-link-button.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import addOrgToProduct from '@/components/add business objects/addOrgToProduct.vue';
import rebootTransceiver from '@/components/elements/functional buttons/reboot-transceiver.vue';
import AddFault from '@/components/add business objects/addFault.vue';
import Collections from '@/components/collections/collections.vue';
import EventSubscriptionChangeLog from '@/components/tables/event-subscription-change-log.vue';
import DeletedEventSubscriptionAudits from '@/components/tables/deletedEventSubscriptionAudits.vue';
import BillingSetupForm from '@/components/billing-setup-form/billing-setup-form.vue';
import BillingSetupButton from '@/components/billing-setup-form/billing-setup-button.vue';
import RouteTab from '@/components/RouteTab.vue';
import VatsTab from './vats/VatsTab.vue';
import RenumberVatsModal from './vats/RenumberVatsModal.vue';
import AddJob from '@/components/add business objects/addJob.vue';
import EntityMap from '@/components/display/maps/entityMap.vue';
import { sortEntitiesByStatus } from '@/common/FormattingUtils';
import ProductCountryFlagRow from '@/components/display/product-country-flag-row.vue';
import {
	getProductAllowedUserIds,
	canAddUsers,
	getProductAllowedUserCount,
} from '@/services/user-service';
import RepairJobTexts from '@/components/tables/repair-job-texts.vue';
import { Constants } from '@/common/Constants';
import AddJobModalsContainer from '@/components/add business objects/add-job/AddJobModalsContainer.vue';
import { ProductStatusService } from '@/services/product-status-service';
import { ProductAccessoryService } from '@/services/product-accessory-service';
import EntityAccessories from '@/components/entityAccessories.vue';
import { ParsingUtil } from '@/common/ParsingUtil';
import ErrorDiv from '@/components/display/errorDiv.vue';
import FaultStatusRow from '@/components/display/information-rows/fault-status-row.vue';
import InformationRow from '@/components/display/information-row.vue';
import SiteRow from '@/components/display/information-rows/site-row.vue';
import OrgRow from '@/components/display/information-rows/org-row.vue';
import NotesRow from '@/components/display/information-rows/notes-row.vue';
import PlanRow from '@/components/display/information-rows/plan-row.vue';
import DirectRow from '@/components/display/information-rows/direct-row.vue';
import TrialRow from '@/components/display/information-rows/trial-row.vue';
import ChangelogLink from '@/components/display/changelog-link.vue';
import LastCheckInTag from '@/components/display/information-rows/last-check-in-tag.vue';
import ProductActionsBar from '@/components/ProductActionsBar.vue';
import WarningIcon from '@/components/display/warning-icon.vue';
import SmsCharges from '@/components/smsCharges/smsCharges.vue';
import { formattedStatus } from '@/common/StatusUtil';
import { getAlertText, showHelpTexts, getOtherActionText } from '@/common/HelpTextUtils';
import TooltipButton from '@/components/elements/buttons/tooltip-button.vue';

@Component({
	computed: {
		ProductOrderStatusEnum() {
			return ProductOrderStatusEnum;
		},
		ProductStatus() {
			return ProductStatus;
		},
	},
	components: {
		RouteTab,
		WarningIcon,
		ProductActionsBar,
		LastCheckInTag,
		ChangelogLink,
		ErrorDiv,
		RenumberVatsModal,
		TrialRow,
		DirectRow,
		PlanRow,
		NotesRow,
		OrgRow,
		SiteRow,
		InformationRow,
		FaultStatusRow,
		EntityAccessories,
		AddJobModalsContainer,
		ProductCountryFlagRow,
		VatsTab,
		infoTabs,
		ExternalLinkButton,
		RouterLinkButton,
		Notifications,
		EventSubscriptions,
		ManageEventSubscriptions,
		UsersTable,
		AddNote,
		AddUserForm,
		secondaryNav,
		vue2Dropzone,
		VatDisplay,
		EditChargesModal,
		SimPro,
		Collections,
		addOrgToProduct,
		rebootTransceiver,
		AddFault,
		ProductTrialModal,
		OrgSuggest,
		ChangeProductOrgModal,
		EventSubscriptionChangeLog,
		DeletedEventSubscriptionAudits,
		BillingSetupForm,
		BillingSetupButton,
		AddJob,
		RepairJobTexts,
		EntityMap,
		SmsCharges,
		TooltipButton,
	},
	validations: {
		userForm: {
			name: { required },
			email: { email, required },
			phone: { numeric, minLength: minLength(6), required },
			permission: {},
		},
	},
	mixins: [validationMixin, TitleMixin],
	methods: {
		getOtherActionText,
		getAlertText,
		showHelpTexts,
	},
})
export default class MilkProductView extends Vue {
	get currentProductTier(): string | null {
		return this.productOrdwayAttributes !== null
			? this.productOrdwayAttributes.ordwayPlanProductTier
			: null;
	}
	public currentPage = 1;
	public perPage = 22;

	get legacySubscriptionItem(): {
		plan: string;
		trialPlan: string;
	} | null {
		if (this.product !== null && this.product.subscriptionitem !== null) {
			return {
				plan: this.product.subscriptionitem.plan,
				trialPlan: this.product.subscriptionitem.trialPlan,
			};
		}
		return null;
	}

	get productPlan(): string {
		if (this.productOrdwayAttributes) {
			return this.productOrdwayAttributes.ordwayPlanName;
		}
		return '';
	}
	get partnerPlan(): string {
		if (this.partnerProductOrdwayAttributes) {
			return this.partnerProductOrdwayAttributes.ordwayPlanName;
		}
		return '';
	}

	public get formattedProductStatus(): string {
		return formattedStatus(
			this.product,
			ProductStatusService.formatProductStatus(
				this.product?.status ?? null,
				this.product?.termsState ?? null,
			),
			'product',
		);
	}

	get billingAttributes() {
		return getProductBillingAttributes(
			this.productOrdwayAttributes,
			this.partnerProductOrdwayAttributes,
			this.product.subscriptionitem,
		);
	}

	get activeVats(): Vat[] {
		return (this.vats ?? []).filter(
			(vat: Vat) => vat.status !== EntityStatus.Removed && vat.status !== EntityStatus.Cancelled,
		);
	}

	public get firstLiveVatId(): string | undefined {
		return this.activeVats.find(vat => vat.status === EntityStatus.Live)?.id?.toString();
	}

	public get vatLocations(): { entityType: string; location: EntityLocation; entity: Vat }[] {
		return (this.vats ?? [])
			.filter(vat => vat.entitylocation !== null)
			.map(vat => ({
				entityType: Constants.ENTITY_TYPE_VAT,
				location: vat.entitylocation!,
				entity: vat,
			}));
	}

	public get mapCenter(): { lat: number; lng: number } | null {
		if (
			this.product?.site === null ||
			!this.product?.site?.latitude ||
			!this.product?.site.longitude
		) {
			return null;
		}
		return {
			lat: parseFloat(this.product.site.latitude),
			lng: parseFloat(this.product.site.longitude),
		};
	}

	public get canCreateInstallJobs(): boolean {
		if (!this.product) {
			return false;
		}
		const pendingEntities = this.product.vats.map(vat => vat.status).includes('pending');
		return pendingEntities;
	}

	public loading = true;
	public product: any | null = null;
	public token = null;
	public org: any | null = null;
	public transceivers: any | null = null;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public liveOptions: any[] | null = null;
	public audits: any[] | null = null;
	public users: any[] | [] = [];
	public allowedUserIds: number[] | null = null;
	public dash: object[] = [];
	public faults = [];
	public permissionAudits = [];
	public jobModal = false;
	public vats: any[] | null = null;
	public milkingTime: any[] | null = null;
	public renderKey = 0;
	public smallScreen = window.innerWidth > 1000;
	public simProRenderKey = 0;
	public signurl: any;
	public imageUrl = '';
	public syncing: boolean = false;
	public partnerOrgs: Org[] | undefined = [];
	public isOnNewOrdwayPlan: boolean = false;
	public jobsExist = false;
	private currentBilling: any | null = null;
	public accessories: any | null = null;
	public accessoriesForInstall: any | null = null;
	public simproJobs: SimproJobDetails[] = [];

	public awsDropzoneOptions = {
		url: process.env.VUE_APP_API_URL + '/vats/s3/awsUpload', // call after AWS upload
		thumbnailWidth: 150,
		maxFilesize: 7.0,
		parallelUploads: 1,
		sendFileToServer: false,
		method: 'POST',
		headers: {
			'Cache-Control': null,
			'X-Requested-With': null,
			Authorization: 'Bearer ' + this.token,
		}, //
	};

	public awsOptions = {
		// signingURL: (f) =>process.env.VUE_APP_API_URL + '/vats/sign/signature', // needs to be correct format
		signingURL: process.env.VUE_APP_API_URL + '/vats/sign/signature', // needs to be correct format
		params: {},
		sendFileToServer: true,
		withCredentials: false,
		headers: { Authorization: 'Bearer ' + this.token },
	};

	public transceiverFields: any[] | null = [
		{ key: 'transceiver.id', label: 'Id', sortable: true },
		{ key: 'label', label: 'Vat', sortable: true },
		{ key: 'transceiver.createdAt', label: 'Created', sortable: true },
		{
			key: 'transceiver.serialNumber',
			label: 'Serial Number',
			sortable: true,
		},
		{ key: 'transceiver.imei', label: 'IMEI', sortable: true },
		{ key: 'transceiver.firmwareVersion', label: 'Firmware' },
		{ key: 'lastcheckin', label: 'Last Check In' },
		{ key: 'reboot', label: 'Reboot' },
	];

	public partnerFields: any[] | null = [
		{ key: 'id', label: 'Id' },
		{ key: 'name', label: 'Name' },
		{
			key: 'contributionTier',
			label: 'Contribution Tier',
			formatter: (val: string) => Vue.filter('titleCase')(val),
		},
	];

	public planOptions = [
		{ value: 'blueTop', text: 'Blue Top' },
		{ value: 'trial', text: 'Trial' },
		{ value: 'trim', text: 'Trim' },
		{ value: 'fullCream', text: 'Full Cream' },
	];

	public fields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'event', label: 'Event' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public billingAudits: any[] | null = null;
	public billingAuditsFields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'event', label: 'Event' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public auditFields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'event', label: 'event' },
		{ key: 'old_values', label: 'From' },
		{ key: 'new_values', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public permissionsAuditFields: any[] | null = [
		{ key: 'user_id', label: 'User Id' },
		{ key: 'user_type', label: 'User Type' },
		{ key: 'event', label: 'Event' },
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'old_values', label: 'Old Values' },
		{ key: 'new_values', label: 'New Values' },
		{ key: 'created_at', label: 'created' },
		{ key: 'updated_at', label: 'updated' },
		{ key: 'user.name', label: 'By' },
	];

	public milkingTimeFields: any[] | null = [
		{ key: 'date', label: 'Date Sent' },
		{ key: 'value', label: 'Ingestion Data' },
	];

	public accessoryFields: any[] | null = [
		{ key: 'serialNumber', label: 'Serial Number', sortable: true },
		{ key: 'accessoryType', label: 'Type', sortable: true },
		{ key: 'entityType', label: 'Attached To Type', sortable: true },
		{ key: 'entityId', label: 'Attached To Id', sortable: true },
		{ key: 'deactivate', label: '' },
	];

	public productOrdwayAttributes: ProductOrdwayAttributes | null = null;

	public entityTypes: Entities[] = [Entities.Vats];

	private api: ProductsApi = new ProductsApi();
	private partnerProductOrdwayAttributes: ProductOrdwayAttributes | null = null;

	private productAccessoriesService: ProductAccessoryService = new ProductAccessoryService();
	private productStatusService: ProductStatusService<Vat> = new ProductStatusService<Vat>(
		this.product,
	);

	public canAddUser: boolean = false;

	private productId?: number | null;

	public s3UploadError(error: any) {
		console.log(error);
	}

	public s3UploadSuccess(location: any) {
		console.log(location);
	}

	public sendingVat1Event(
		file: any,
		xhr: any,
		formData: { append: (arg0: string, arg1: any) => void },
	) {
		if (this.vats) {
			formData.append('vatId', this.vats[0].id);
		}
	}

	public sendingVat2Event(
		file: any,
		xhr: any,
		formData: { append: (arg0: string, arg1: any) => void },
	) {
		if (this.vats) {
			formData.append('vatId', this.vats[1].id);
		}
	}

	public sendingVat3Event(
		file: any,
		xhr: any,
		formData: { append: (arg0: string, arg1: any) => void },
	) {
		if (this.vats) {
			formData.append('vatId', this.vats[2].id);
		}
	}

	public uploadFiles() {
		this.$refs.myVueDropzone.setAWSSigningURL(this.signurl);
		this.$refs.myVueDropzone.processQueue();
	}

	public reRender() {
		this.renderKey > 0 ? this.renderKey-- : this.renderKey++;
	}

	public checkThisObject(object: any, path: string, defaultMessage: any) {
		return _.get(object, path, defaultMessage);
	}

	public async created() {
		this.productId = ParsingUtil.parseId(this.$route.params.productId);
		await this.onCreated();

		this.$watch(
			() => this.$route.params.productId,
			async (to, from) => {
				this.productId = ParsingUtil.parseId(to) ?? this.productId;
				await this.onCreated();
			},
		);
	}

	private async onCreated() {
		await this.load();
		if (this.$route.params.showJob) {
			this.$bvModal.show('jobModal');
		}
		await Vue.nextTick();
		if (
			this.productOrdwayAttributes === null &&
			this.product.status !== 'cancelled' &&
			this.product.status !== 'removed'
		) {
			(this.$refs.billingSetupButton as BillingSetupButton)?.openEditBillingModal();
		}
	}

	@Provide('refreshMilk')
	public async load() {
		if (this.productId == null) {
			this.loading = false;
			return;
		}

		await this.loadProduct();
		await this.loadPartners();
		await this.loadBilling();

		this.productStatusService = new ProductStatusService<Vat>(this.product);
	}

	public async loadProduct() {
		if (this.productId == null) {
			this.loading = false;
			return;
		}
		try {
			const data = await new ProductsApi().getProductById(this.productId!, {
				params: {
					include:
						'accessories,' +
						'audits,' +
						'audits.user,' +
						'faults,' +
						'faults.owner,' +
						'org,' +
						'permission_audits,' +
						'permission_audits.user,' +
						'site,' +
						'site.address,' +
						'subscriptionitem,' +
						'subscriptionitem.audits,' +
						'subscriptionitem.audits.user,' +
						'transceivers,' +
						'productstatuschanges,' +
						'vats,' +
						'vats.audits,' +
						'vats.audits.user,' +
						'vats.entitylocation,' +
						'vats.sensors.transceiver.site,' +
						'vats.transceiver.site,' +
						'vats.customformula,' +
						'vats.allcorrections,' +
						'vats.currentcorrection,' +
						'discount',
				},
			});
			this.setProduct(
				data as AxiosResponse<Product & { org: Org; transceivers: Transceiver[]; audits: Audit[] }>,
			);
			await this.fetchProductOrdwayAttribute();
			this.loadDash();
			this.loadUsers();
			this.loadMilkingTime();
			this.loadAccessoriesForInstall();
		} catch (e) {
			console.log(e);
		} finally {
			this.loading = false;
		}
	}

	public async loadPartners() {
		try {
			const data = await new ProductsApi().getProductPartnerOrgs(this.productId!);
			this.partnerOrgs = data.data.data.filter(p => p !== null);
		} catch (e) {
			this.partnerOrgs = undefined;
			console.log(e);
		}
	}

	// When next touched, refactor. See water product view.vue for an example
	public async loadBilling() {
		try {
			const data = await new BillingApi().currentBilling(this.productId!);
			this.currentBilling = data.data.data;
			if (this.currentBilling.partnerId !== null) {
				const partners = await new OrgsApi().orgGetBillingPartnersByProductType(ProductType.Milk);
				const partner = partners.data.data?.find(
					partner => partner.id == this.currentBilling.partnerId,
				);
				if (partner) {
					this.currentBilling = { ...this.currentBilling, partnerName: partner.name };
				}
			}
		} catch (e) {
			console.log(e);
		}
	}

	public async onOrgChanged() {
		await this.loadProduct();
		this.closeOrgModal();
		new Toast().makeToast('Org changed successfully', 'Success', 'success', false);
	}

	public async resetProductOrg() {
		await this.loadProduct();
	}

	public setJobsToTrue() {
		this.jobsExist = true;
	}

	public simproJobsLoaded(simproJobs: SimproJobDetails[]) {
		this.simproJobs = simproJobs;
		this.product = {
			...this.product,
			simproJobs: simproJobs,
		};
	}

	public async loadUsers() {
		try {
			const { data } = await this.api.getProductById(this.productId!, {
				params: { include: 'users' },
			});
			this.allowedUserIds = await getProductAllowedUserIds(this.productId!);
			const allowedUserCount = await getProductAllowedUserCount(this.productId!);
			this.canAddUser = allowedUserCount == null || this.users.length < allowedUserCount;
			this.setUsers(data);
		} catch (e) {
			console.log(e);
		}
		this.reRender();
	}

	public async loadDash() {
		try {
			const api = new ProductsApi();
			const response = await api.getProductDash(this.productId!);
			this.setDash(response);
		} catch (e) {
			console.log(e);
		}
	}

	public async loadMilkingTime() {
		try {
			const api = new ProductsApi();
			const response = await api.getProductMilkingTimeWindow(this.productId);
			this.setMilkingTime(response);
		} catch (e) {
			console.log(e);
		}
	}

	public setProduct(
		data: AxiosResponse<
			Product & {
				org: Org;
				transceivers: Transceiver[];
				audits: Audit[];
				accessories: ProductAccessory[];
			}
		>,
	) {
		this.product = data.data;
		this.product.org = this.product.org ?? {};
		this.org = data.data.org;
		this.vats = sortEntitiesByStatus(data.data.vats ?? []);
		this.accessories = data.data.accessories;
		this.transceivers = data.data.transceivers;
		this.audits = data.data.audits;
		this.billingAudits = data?.data?.subscriptionitem?.audits ?? [];
		if (this.vats) {
			this.vats.map(vat =>
				vat.audits
					.sort((a: { created_at: number }, b: { created_at: number }) =>
						a.created_at < b.created_at ? 1 : -1,
					)
					.forEach((n: { fields: string }) => {
						n.fields = n.fields.split(',').join(', ');
					}),
			);
			this.vats.forEach(vat =>
				this.dash.push({
					vatTemp: { date: '', value: '', outOfSpec: 'false' },
					inletTemp: { date: '', value: '', outOfSpec: 'false' },
					volume: { date: '', value: '', outOfSpec: 'false' },
					stirrer: { date: '', value: '', outOfSpec: 'false' },
					power: { date: '', value: '', outOfSpec: 'false' },
					wash: { date: '', value: '', outOfSpec: 'true' },
				}),
			);
		}
	}

	public setUsers(data: any) {
		this.users = data.users || [];
	}

	public setDash(data: any) {
		this.dash = data.data.data;
	}

	public setMilkingTime(data: any) {
		this.milkingTime = data.data.data;
	}

	public pageTitle() {
		return `Milk | ${this.product ? this.product.supplierNumber : ''}`;
	}

	public userFromId(userId: any) {
		const user = this.users.find(u => u.id === userId);
		return user ? user.name : userId ? `user ${userId} (not found on product)` : 'no user Id';
	}

	public orgRowClicked(item: { id: any }, newtab: boolean, route: any) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: route,
				params: { orgId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: route,
				params: { orgId: item.id },
			} as any);
		}
	}

	public loadSimpro() {
		this.simProRenderKey === 0 ? (this.simProRenderKey += 1) : (this.simProRenderKey -= 1);
	}

	public async activity(action: string) {
		if (!this.product?.id) return;
		try {
			const response = await new ProductsApi().productFaults(this.product.id, {
				data: { action },
			});
			new Toast().makeToast(
				`Product fault status has been set to ${action}`,
				'fault status',
				'success',
				false,
			);
		} catch (e) {
			console.log(e);
			new Toast().makeToast(
				`Product fault status has not been set to ${action}`,
				'fault status',
				'danger',
				true,
			);
		}
	}

	public async deactivateProduct() {
		if (
			this.product?.id &&
			confirm(
				'This is for a product that has been installed and is now being removed, are you sure you want to remove?',
			)
		) {
			const api = new ProductsApi();
			let error;

			try {
				const response = await this.api.deactivateProduct(this.product.id);
			} catch (e) {
				console.log(e);
				if (e.response) {
					error = 'Error Deactivating Product,' + e.response.data.message;
				} else if (e.request) {
					error = 'Error Deactivating Product, network Error';
				} else {
					error = 'Error Deactivating Product, unknown Error';
				}
				new Toast().makeToast(error, 'Error Deactivating Product', 'danger', true);
				this.submitStatus = 'ERROR';
				return;
			}
			new Toast().makeToast('Product Deactivated', 'Product Deactivated', 'success');
			await this.load();
		}
	}

	public async cancelProduct() {
		if (
			this.product?.id &&
			confirm(
				'This is for a product that has been not been installed and is now being cancelled, are you sure you want to cancel?',
			)
		) {
			const api = new ProductsApi();
			try {
				const response = await api.cancelProduct(this.product.id);
			} catch (e) {
				const error = e.response.data.errors.name[0];
				new Toast().makeToast(error, 'Error Cancelling Product', 'danger', true);
				this.submitStatus = 'ERROR';
				return;
			}
			new Toast().makeToast('Product Cancelled', 'Product Cancelled', 'success');
			await this.load();
		}
	}

	public openChargesModal(): void {
		this.$bvModal.show('edit-charges-modal');
	}

	public openProductOrgChangeModal(): void {
		this.$bvModal.show('product-org-change-modal');
	}

	public closeOrgModal(): void {
		this.$bvModal.hide('product-org-change-modal');
	}

	public async signOffAndCreateSubscription(confirmedPlan: OrdwayPlan) {
		this.submitStatus = 'PENDING';
		this.signOffProduct().then(async () => {
			if (this.submitStatus !== 'ERROR') {
				this.onSuccess();
			}
		});
	}

	public newFault(e: Event) {
		this.product.faults.push(e);
	}

	public refreshLoad() {
		this.load();
	}

	public async addVat(): Promise<void> {
		const api = new VatsApi();
		await api.addVat({ data: { productId: this.product.id } });
		await this.loadProduct();
		new Toast().makeToast('Vat added successfully', 'Success', 'success');
		await navigateTo(this.$router, {
			name: 'products.milk.vats.overview',
			params: { productId: this.$route.params.productId },
		});
	}

	private async fetchProductOrdwayAttribute(): Promise<void> {
		try {
			const productOrdwayAttributeResponse: AxiosResponse<ProductOrdwayAttributes> = await OrdwayService.fetchProductOrdwayAttributes(
				this.product.id,
				this.product.orgId,
			);
			this.productOrdwayAttributes = productOrdwayAttributeResponse.data;
		} catch (errorResponse) {
			const error: AxiosError = errorResponse as AxiosError;
			if (error.response) {
				const errorMessage = error.response.data.errors;
				new Toast().makeToast(errorMessage, 'No plan found for this product', 'danger', true);
			} else {
				new Toast().makeToast(
					'There was a problem loading the Ordway attributes for this product, please let the software team know',
					'Error loading Ordway attributes',
					'danger',
					true,
				);
			}
		}
		if (this.productOrdwayAttributes) {
			this.isOnNewOrdwayPlan = await OrdwayService.isOnNewOrdwayPlan(
				this.product,
				this.productOrdwayAttributes,
			);
		}
	}

	public async syncOrdwayDraftSubscription() {
		this.syncing = true;
		await OrdwayService.syncOrdwayDraftSubscription(this.product.id);
		this.loadProduct();
		this.syncing = false;
		new Toast().makeToast('Ordway Draft Subscription synchronised', 'Successful', 'success');
	}

	private onSuccess(): void {
		new Toast().makeToast(
			'Successfully Signed Off Product',
			'Successful Allocation and Subscription Creation',
			'success',
		);
		setTimeout(() => {
			this.closeChargesModal();
			this.load();
			this.reRender();
		}, 1000);
	}

	private closeChargesModal(): void {
		this.$bvModal.hide('edit-charges-modal');
	}

	private async createSubscription(confirmedPlan: OrdwayPlan): Promise<void> {
		if (!this.product?.id) return;

		const subscriptionCreateParams: OrdwaySubscriptionParams = {
			orgId: this.product.orgId,
			productId: this.product.id,
			siteId: this.product.siteId,
			charges: confirmedPlan.charges,
		};
		await OrdwayService.createOrdwaySubscription(subscriptionCreateParams);
	}

	private async signOffProduct(): Promise<void> {
		try {
			const product = { ...this.product };
			product.transceivers = this.transceivers;
			if (this.vats) {
				product.vats = this.vats.map(vat => {
					return {
						vatId: vat.id,
						vatSize: vat.sizeString,
						vatType: vat.formula,
						offset: vat.vatOffset,
						state: vat.state,
						transceiverId: vat.transceiverId,
					};
				});
				product.vatSensors = [];
				this.vats.map(vat => {
					vat.sensors.map((sensor: { id: any; type: any; vatId: any; transceiverId: any }) => {
						product.vatSensors.push({
							sensorId: sensor.id,
							sensorType: sensor.type,
							vatId: sensor.vatId,
							transceiverId: sensor.transceiverId,
						});
					});
				});
			}
			await this.api.productSignoff(this.product.id, {
				data: product,
			});
		} catch (e) {
			const error = e.response && e.response.data ? e.response.data.message || e : e;
			console.log(error);
			new Toast().makeToast(error, 'Error Signing Off', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
	}

	public deactivateAccessory(accessoryId: number): void {
		this.productAccessoriesService.deactivateProductAccessory(accessoryId);
	}

	public async loadAccessoriesForInstall() {
		let productAccessories: any[] = [];
		for (const transceiver of this.transceivers) {
			if (!transceiver?.id) continue;
			const accessories = await this.productAccessoriesService.getProductAccessoriesForTransceiver(
				transceiver.id,
			);
			if (accessories.errorMessage) {
				new Toast().makeToast(
					accessories.errorMessage,
					'Error Getting Available Product Accessories',
					'danger',
				);
				continue;
			}
			productAccessories = [...productAccessories, ...(accessories.accessories ?? [])];
		}
		this.accessoriesForInstall = productAccessories;
	}

	public get partnerContribution(): string {
		return `${
			this.currentBilling && this.currentBilling.partnerContributionTier
				? `${this.$options.filters?.capitalise(
						this.$options.filters?.decamelize(this.currentBilling.partnerContributionTier),
				  )} | ${this.currentBilling.partnerName}`
				: 'No Contribution'
		}`;
	}
}
